import React, { useMemo } from "react";
import { Link } from "react-router-dom";
import useThemeMode from "../../hooks/useThemeMode";
import { getMarketingTheme } from "../../utils/marketingTheme";
import useI18n from "../../i18n/useI18n";

const PublicPricingHero = () => {
  const { isDark } = useThemeMode();
  const { t } = useI18n();
  const colors = useMemo(() => getMarketingTheme(isDark), [isDark]);

  const tt = (key, fallback) => {
    const value = t(key);
    return value === key ? fallback : value;
  };

  return (
    <section
      style={{
        padding: "84px 20px 40px",
        background: colors.heroBg,
      }}
    >
      <div
        style={{
          maxWidth: "1200px",
          margin: "0 auto",
          textAlign: "center",
        }}
      >
        <div
          style={{
            display: "inline-flex",
            alignItems: "center",
            gap: "8px",
            padding: "8px 14px",
            borderRadius: "999px",
            background: colors.badgeBg,
            color: colors.badgeText,
            fontWeight: "700",
            fontSize: "12px",
            marginBottom: "18px",
            border: isDark ? `1px solid ${colors.border}` : "none",
          }}
        >
          {tt(
            "publicPricingHero.badge",
            "Monthly or yearly pricing for creators"
          )}
        </div>

        <h1
          style={{
            fontSize: "clamp(2.4rem, 5vw, 4.2rem)",
            lineHeight: "1.04",
            margin: "0 0 16px",
            color: colors.text,
            letterSpacing: "-0.03em",
          }}
        >
          {tt(
            "publicPricingHero.title",
            "Choose the Hookora plan that fits your creative speed"
          )}
        </h1>

        <p
          style={{
            maxWidth: "760px",
            margin: "0 auto 24px",
            fontSize: "17px",
            lineHeight: "1.75",
            color: colors.textSoft,
          }}
        >
          {tt(
            "publicPricingHero.description",
            "Start free, build momentum, and upgrade when you need more generations, more saved assets, and a stronger workflow for consistent content output. Choose monthly billing or save 17% with yearly billing."
          )}
        </p>

        <div
          style={{
            display: "flex",
            gap: "12px",
            justifyContent: "center",
            flexWrap: "wrap",
          }}
        >
          <Link
            to="/register"
            style={{
              textDecoration: "none",
              background: "linear-gradient(135deg, #2563eb, #7c3aed)",
              color: "#fff",
              padding: "14px 18px",
              borderRadius: "12px",
              fontWeight: "800",
              boxShadow: "0 12px 28px rgba(79, 70, 229, 0.24)",
            }}
          >
            {tt("publicPricingHero.startFree", "Start Free")}
          </Link>

          <Link
            to="/features"
            style={{
              textDecoration: "none",
              background: colors.panelBg,
              color: colors.text,
              padding: "14px 18px",
              borderRadius: "12px",
              fontWeight: "800",
              border: `1px solid ${colors.borderStrong}`,
            }}
          >
            {tt("publicPricingHero.exploreFeatures", "Explore Features")}
          </Link>
        </div>
      </div>
    </section>
  );
};

export default PublicPricingHero;